var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.417 13.182l-.397 5.584c.568 0 .814-.244 1.11-.537l2.662-2.545 5.519 4.04c1.012.565 1.725.268 1.998-.93L23.93 1.82c.322-1.497-.54-2.082-1.526-1.715L1.115 8.258C-.34 8.822-.318 9.632.866 9.998l5.443 1.694L18.954 3.78c.595-.394 1.136-.176.69.219L9.418 13.181z"}));
}

Telegram.defaultProps = {"viewBox":"0 0 24 20","fill":"currentColor"};

module.exports = Telegram;

Telegram.default = Telegram;
